import { render, staticRenderFns } from "./LoadMorePagination.vue?vue&type=template&id=df9bea7c&scoped=true"
import script from "./LoadMorePagination.vue?vue&type=script&lang=js"
export * from "./LoadMorePagination.vue?vue&type=script&lang=js"
import style0 from "./LoadMorePagination.vue?vue&type=style&index=0&id=df9bea7c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df9bea7c",
  null
  
)

export default component.exports